import React from 'react';
import MfDiagnosticCriteria from './MfDiagnosticCriteria';
import MfRiskScores from './MfRiskScores';
import Mpn10Questionnaire from './Mpn10Questionnaire';

interface MfViewProps {
  activeTab: string;
}

const MfView: React.FC<MfViewProps> = ({ activeTab }) => {
  switch (activeTab) {
    case 'diagnosis':
      return <MfDiagnosticCriteria />;
    case 'risk':
      return <MfRiskScores />;
    case 'mpn10':
      return <Mpn10Questionnaire />;
    default:
      return null;
  }
};

export default MfView;
